// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--qzsjH","graphic":"Spinner--graphic--kqWQZ","spin":"Spinner--spin--kJ7Zm"};